import { FiSettings, FiMoon, FiSun } from 'react-icons/fi';
import { usePreferences } from '../../contexts/PreferencesContext';
import styles from './DashboardHeader.module.css';

const DashboardHeader = ({ user, onOptionsClick }) => {
  const { themeMode, toggleThemeMode } = usePreferences();

  return (
    <header className={styles.header}>
      <div className={styles.user}>
        {user?.avatar_emoji} {user?.tagname}
      </div>
      <div className={styles.actions}>
        <button className={styles.iconBtn} onClick={toggleThemeMode}>
          {themeMode === 'dark' ? <FiSun /> : <FiMoon />}
        </button>
        <button className={styles.iconBtn} onClick={onOptionsClick}>
          <FiSettings />
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;